// blockchainExplorer.js

// Base explorer URLs for supported networks
const EXPLORERS = {
  ALGORAND: {
  account: (address) => `${process.env.REACT_APP_PARAWALLET_BASE_URL}/address/${address}`,
    transaction: (txId) => `${process.env.REACT_APP_PARAWALLET_BASE_URL}/tx/${txId}`,
  },
  POLYGON: {
    account: (address) => `${process.env.REACT_APP_POLYGON_BASE_URL}/address/${address}`,
    transaction: (txId) => `${process.env.REACT_APP_POLYGON_BASE_URL}/tx/${txId}`,
  },
  MST: {
    account: (address) => `${process.env.REACT_APP_MST_BASE_URL}/address/${address}`,
    transaction: (txId) => `${process.env.REACT_APP_MST_BASE_URL}/tx/${txId}`,
  }
};


// Utility function to get account link
export const getAccountLink = (network, address) => {
  const explorer = EXPLORERS[network.toUpperCase()];
  if (!explorer) throw new Error(`Unsupported network: ${network}`);
  return explorer.account(address);
};

export const getExplorerButtonText = (network) => {
  switch (network.toLowerCase()) {
    case 'algorand':
      return 'View on Pera Explorer';
    case 'polygon':
      return 'View on PolygonScan';
    case 'mst':
      return 'View on MST Scan';
  }
  return 'View on Explorer';
}

// Utility function to get transaction link
export const getTransactionLink = (network, txId) => {
  const explorer = EXPLORERS[network.toUpperCase()];
  if (!explorer) throw new Error(`Unsupported network: ${network}`);
  return explorer.transaction(txId);
};

// Optional: export all explorers for direct use
export default EXPLORERS;
